<template lang="pug">
    .balaclava(ref='animation')
        img.balaclava__lighting(ref='lightingLeft' src='../../assets/img/animations/lighting-left.svg')
        img.balaclava__lighting(ref='lightingRight' src='../../assets/img/animations/lighting-right.svg')
        img.balaclava__mask(src='../../assets/img/animations/balaclava.svg')
</template>
<script>
import {gsap} from 'gsap';
import {mixinAnimation} from '../mixins/mixinAnimation';

export default {
    mixins: [mixinAnimation],
    methods: {
        createAnimation() {
            this.createTimeline();
            this.createScroll('bottom-bottom', 'bottom-top');
        },
        createTimeline() {
            this.timeline = gsap.timeline({paused: true});
            this.timeline
                .fromTo(this.$refs.lightingLeft, {x: 0, y: 0}, {duration: 3, x: '-50', y: '-50', ease: 'none'}, 0)
                .fromTo(this.$refs.lightingRight, {x: 0, y: 0}, {duration: 3, x: '50', y: '-50', ease: 'none'}, 0);
            this.timeline.progress(0.0001);
            this.timeline.pause();
        }
    }
};
</script>
<style lang="scss">
.balaclava {
    width: 80%;
    margin: auto;
    position: relative;
    &__lighting {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
    }
    &__mask {
        position: relative;
        z-index: 2;
    }
}
</style>
